var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin-page" }, [
    _c("div", { staticClass: "main-cnt" }, [
      _c("div", { staticClass: "content-white" }, [
        _c("div", { staticClass: "content-body" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("div", { staticClass: "row h-100" }, [
              _c("div", { staticClass: "col-12 h-100" }, [
                _c("div", { staticClass: "block-cnt" }, [
                  _vm.loading == true
                    ? _c("div", {
                        staticClass: "loading",
                        attrs: { "data-vv-scope": "s3" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.listCompany != null && _vm.loading == false
                    ? _c(
                        "div",
                        {
                          staticClass: "table-list",
                          attrs: { "data-vv-scope": "s4" }
                        },
                        [
                          _c(
                            "table",
                            { staticClass: "table" },
                            [
                              _c("tr", [
                                _c("th", { staticClass: "no-checkbox" }, [
                                  _vm._v(_vm._s(_vm.$t("company.general.code")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("company.general.full_name"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("company.general.cabinet_id"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.listCompany, function(company) {
                                return _c("tr", { key: company.id }, [
                                  _c("td", { staticClass: "no-checkbox" }, [
                                    _vm._v(_vm._s(company.code))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(company.name))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(company.cabinet_id))])
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.listCompany == null && _vm.loading == false
                    ? _c(
                        "div",
                        {
                          staticClass: "no-data",
                          attrs: { "data-vv-scope": "s6" }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("general.no_data")) +
                              "\n                                "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6b35048", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6b35048","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/CompanyManagement/List.vue
// module id = null
// module chunks = 